"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_tv__tv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;}")), /*#__PURE__*/React.createElement("title", null, "tv-tv"), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 111.62,
    y1: 104,
    x2: 120,
    y2: 72.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 111.62,
    y1: 104,
    x2: 103.56,
    y2: 72.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.5,
    y1: 104,
    x2: 80.5,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 89,
    y1: 72,
    x2: 72,
    y2: 72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 36,
    width: 152,
    height: 104,
    rx: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 60,
    y1: 156,
    x2: 132,
    y2: 156
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96,
    y1: 144,
    x2: 96,
    y2: 154
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 192,
    height: 192
  }));
}

var _default = ic_tv__tv;
exports.default = _default;